module.exports = __webpack_public_path__ + "img/bg-1@2x.cd21b24e.png";